module.exports = __webpack_public_path__ + "media/images/arrow-cffe52b35c58c60154d7c131150b5370.svg";